// Components
import { RootState } from '../index';

const getManagedUsersData = (state: RootState) => state.managedUsersDataSlice.managed_users;

export { getManagedUsersData };
